import React, { ReactElement } from 'react';

const FilteredWidget: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const {
    widgetName,
    widgetSettings,
    customWidgetSettings,
    children,
  } = props;

  const isCustomWidgetVisible: boolean = customWidgetSettings && customWidgetSettings[widgetName]
    ? customWidgetSettings[widgetName].isVisible : false;
  const isDefaultWidgetVisible: boolean = widgetSettings && widgetSettings[widgetName]
    ? widgetSettings[widgetName].isVisible : false;
  const isWidgetVisible: boolean = (customWidgetSettings ? isCustomWidgetVisible : true)
    && isDefaultWidgetVisible;

  if (!isWidgetVisible) {
    return null;
  }

  return children;
});

export default FilteredWidget;
